<template>
  <v-container id="china_wedding">
    <v-layout column pa-4 mb-2>
      <v-flex class="display-2 text-xs-center my-5">China Wedding</v-flex>
      <v-divider insert></v-divider>
      <v-container lg4>
        <v-flex justify-center>
          <youtube
            :video-id="this.videoId"
            :player-width="780"
            :player-height="480"
          />
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed';

export default {
  name: 'Video',
  data() {
    return {
      videoId: getIdFromURL('https://youtu.be/S7W_EzdlF0c'),
    };
  },
};

</script>

<style scoped></style>
